module.exports = __webpack_public_path__ + "static/img/PY.72b20890.png";